import React from 'react';
import {
  FormRow,
  FormLabel,
  FormFieldWrapper,
  FormRowProps
} from '../form-input';
import { ColorPicker } from '../color-picker';

export interface ColorPickerFieldProps extends FormRowProps {
  label: string;
  value?: string;
  onChange: (value?: string) => void;
}

export function ColorPickerField(props: ColorPickerFieldProps) {
  const { label, value, onChange, ...formRowProps } = props;

  const handleChange = (newValue?: string) => {
    onChange(newValue);
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <FormFieldWrapper>
        <ColorPicker color={value ?? '#ffffff'} onChange={handleChange} />
      </FormFieldWrapper>
    </FormRow>
  );
}
